import React, { useState } from "react"
import FdlButton from '../buttons/FdlButton';
import EditFramingIntentModal from "../fdl_forms/edit/EditFramingIntentModal";
import EditCanvasModal from "../fdl_forms/edit/EditCanvasModal";

import { Box } from "@mui/system"
import { Typography, Divider } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import HelpTooltip from '../popover/HelpTooltip';

export default function ListTree(props) {
    const { style, intentData, setIntentData, cameraData, setCameraData, display } = props;
    const [isCollapsed, setIsCollapsed] = useState({});
    const [editIntent, setEditIntent] = useState({});
    const [editCanvas, setEditCanvas] = useState({});
    const [isOpenIntent, setIsOpenIntent] = useState(false);
    const [isOpenCanvas, setIsOpenCanvas] = useState(false);
    let camDataForDisplay = {};
    let intentDataForDisplay = {};

    const textColor = {
        color: 'rgb(168, 206, 208)'
    }

    const treeStyle = {
        ...style,
        backgroundColor: 'rgba(107, 164, 125, 0.3)',
        color: textColor,
        borderRadius: '8px',
        height: '100%',
        padding: '20px',
        display: display
    };

    const headerStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        maxWidth: '100%'

    }

   

    const iconStyle = {
        fontSize: '16px',
        display: 'flex',
    }

    const iconButtonStyle = {
        minWidth: '20px',
        width: '30px',
        height: '30px',
        marginLeft: '10px'
    }

    const treeItemStyle = {
        
    }

    const listHeadingStyle = {
        overflowWrap: "anywhere",
    }



    if (cameraData !== undefined) {
        camDataForDisplay = cameraData;
    } else {
        camDataForDisplay = null;
    };

    if (intentData !== undefined) {
        intentDataForDisplay = intentData;
    } else {
        intentDataForDisplay = null;
    };
    
    // ============================== UPDATE FRAMING INTENT ==============================
    const openEditFramingIntent = (data) => {
        setEditIntent(data);
        setIsOpenIntent(true);
    };

    const openEditCanvas = (data) => {
        setEditCanvas(data);
        setIsOpenCanvas(true);
    }

    const closeEditFramingIntent = () => {
        setEditIntent({});
        setIsOpenIntent(false);
    }

    const closeEditCanvas = () => {
        setEditCanvas({});
        setIsOpenCanvas(false);
    }

    const renderEditFramingIntent = () => {
        return (
            <EditFramingIntentModal open={isOpenIntent} handleClose={closeEditFramingIntent} intentName={editIntent} intentData={intentData} setIntentData={setIntentData} />
        );
    }

    const renderEditCanvas = () => {
        return (
            <EditCanvasModal open={isOpenCanvas} handleClose={closeEditCanvas} cameraName={editCanvas} cameraData={cameraData} setCameraData={setCameraData} />
        )
    }
    // ============================== UPDATE FRAMING INTENT ==============================

    const toggleCollapse = (key) => {
        setIsCollapsed((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
    };

    const deleteFramingIntent = (intentName) => {
        const updatedData = { ...intentData };
        delete updatedData[intentName];
        setIntentData(updatedData);
    }

    const deleteCamera = (cameraName) => {
        const updatedData = { ...cameraData };
        delete updatedData[cameraName];
        setCameraData(updatedData)
    }

    const treeHeaderContainer = {
        display: 'flex',
        justifyContent: 'space-between',
        maxWidth: '100%'
    }   



    const renderFramingIntents = () => (
        Object.keys(intentDataForDisplay).length != 0 ?
            Object.keys(intentDataForDisplay).map((intentName) => (
                <div key={intentName} style={{ treeItemStyle }}>
                    <div style={treeHeaderContainer}>
                        <Box onClick={() => toggleCollapse(intentName)} sx={headerStyle}>
                            {isCollapsed[intentName] ? <ExpandLessIcon sx={{ color: 'white' }} /> : <ExpandMoreIcon sx={{ color: 'white' }} />}
                            <Typography style={listHeadingStyle} variant="body1" sx={textColor}>{intentDataForDisplay[intentName]['Intent ID']}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'right' }}>
                            <FdlButton
                                onClick={() => openEditFramingIntent(intentName)}
                                text={<EditIcon sx={iconStyle} />}
                                style={iconButtonStyle}
                            />
                            <FdlButton
                                onClick={() => deleteFramingIntent(intentName)}
                                text={<DeleteIcon sx={iconStyle} />}
                                style={iconButtonStyle}
                            />
                        </Box>
                    </div>

                    {isCollapsed[intentName] && (
                        <div>
                            {Object.keys(intentDataForDisplay[intentName]).map((key) => (
                                <Typography variant="body2" sx={textColor} key={key}>
                                    <li>
                                        <strong>{key}:</strong> {intentDataForDisplay[intentName][key]}
                                    </li>
                                </Typography>
                            ))}
                            
                        </div>
                    )}
                    <Divider sx={{ bgcolor: 'silver', margin: '10px 0' }} />
                </div>
            ))
        :
        <p style={{marginTop: '-15px'}}>-</p>
    );

    const renderCameras = () => (
        Object.keys(camDataForDisplay).length != 0 ?
            Object.keys(camDataForDisplay).map((cameraName) => (
                <div key={cameraName} style={{treeItemStyle}}>
                    <div style={treeHeaderContainer}>
                        <Box onClick={() => toggleCollapse(cameraName)} sx={headerStyle}>
                            {isCollapsed[cameraName] ? <ExpandLessIcon sx={{ color: 'white' }} /> : <ExpandMoreIcon sx={{ color: 'white' }} />}
                            <Typography style={listHeadingStyle} variant="body1" sx={textColor}>{camDataForDisplay[cameraName]['Camera ID']}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'right' }}>
                                <FdlButton
                                    onClick={() => openEditCanvas(cameraName)}
                                    text={<EditIcon sx={iconStyle} />}
                                    style={iconButtonStyle}
                                />
                                <FdlButton
                                    onClick={() => deleteCamera(cameraName)}
                                    text={<DeleteIcon sx={iconStyle} />}
                                    style={iconButtonStyle}
                                />
                            </Box>
                    </div>

                    {isCollapsed[cameraName] && (
                        <div>
                            {Object.keys(camDataForDisplay[cameraName]).map((key) => (
                                <Typography variant="body2" sx={textColor} key={key}>
                                    <li>
                                        <strong>{key}:</strong> {camDataForDisplay[cameraName][key]}
                                    </li>
                                </Typography>
                            ))}
                            
                        </div>
                    )}
                    <Divider sx={{ bgcolor: 'silver', margin: '10px 0' }} />
                </div>
            ))
            :
            <p style={{marginTop: '-15px'}}>-</p>
    );

    return (
        <Box sx={treeStyle}>
            <h2 style={{marginTop:'0px', color: textColor['color']}}>Your framing data
                <HelpTooltip 
                    text="Add framing intents and canvases to populate this list." 
                />
            </h2>
            <h3 style={{color: textColor['color']}}>Framing Intents</h3>
            
            {renderFramingIntents()}

            <h3 style={{color: textColor['color']}}>Cameras</h3>
            {renderCameras()}

            {renderEditFramingIntent()}
            {renderEditCanvas()}
        </Box>
    );
};